import { render, staticRenderFns } from "./VariantSearch.vue?vue&type=template&id=0ba7ac80"
import script from "./VariantSearch.vue?vue&type=script&lang=js"
export * from "./VariantSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports